export default __webpack_public_path__ + "static/media/chair1.cc353113.png";